import React, { useState } from 'react';
import { PlanTier } from '../../types/entitlements';
import { upsellCopy } from '../../utils/upsellCopy';
interface ProTooltipProps {
  children: ReactNode;
  feature: string;
  plan: PlanTier;
  onSeePlan?: () => void;
}
export function ProTooltip({
  children,
  feature,
  plan,
  onSeePlan
}: ProTooltipProps) {
  const [isVisible, setIsVisible] = useState(false);
  return <div className="relative inline-block" onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)} onFocus={() => setIsVisible(true)} onBlur={() => setIsVisible(false)} data-id="element-3564">
      {children}
      {isVisible && <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 z-50 w-64" data-id="element-3565">
          <div className="bg-gray-900 text-white text-xs rounded-lg px-3 py-2 shadow-lg" data-id="element-3566">
            <p className="mb-2" data-id="element-3567">{upsellCopy.lockedFeature(plan, feature)}</p>
            <button onClick={e => {
          e.stopPropagation();
          onSeePlan?.();
        }} className="text-blue-300 hover:text-blue-200 font-medium" data-id="element-3568">
              {upsellCopy.ctas.seePlan} →
            </button>
          </div>
          <div className="w-2 h-2 bg-gray-900 transform rotate-45 absolute top-full left-1/2 -translate-x-1/2 -mt-1" data-id="element-3569" />
        </div>}
    </div>;
}